import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BaseComponent } from './core/layout/base/base.component';
import { LoginComponent } from './modules/auth/login/login.component';
import { MainContentComponent } from './modules/dashboard/main-content/main-content.component';
import { AuthGuard } from './core/auth/auth.guard';
import { MarketingRoleGuard } from './core/auth/marketing-role.guard';
import { ForbiddenComponent } from './modules/auth/forbidden/forbidden/forbidden.component';
import { CprRoleGuard } from './core/auth/cpr-role.guard';
import { CaseManagementRoleGuard } from './core/auth/case-management-role.guard';
const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'app',
    component: BaseComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard, CprRoleGuard],
      },
      {
        path: 'dashboard/mkt',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard, MarketingRoleGuard],
      },
      {
        path: 'dashboard/cm',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard, CaseManagementRoleGuard],
      },
      {
        path: 'organization',
        loadChildren: () => import('./modules/organization/organization.module').then(m => m.OrganizationModule),
        canActivate: [CprRoleGuard],
      },
      {
        path: 'employees',
        loadChildren: () => import('./modules/employee/employee.module').then(m => m.EmployeeModule),
        canActivate: [CprRoleGuard],
      },
      {
        path: 'individuals',
        loadChildren: () => import('./modules/individuals/individuals.module').then(m => m.IndividualsModule),
        canActivate: [CprRoleGuard],
      },
      {
        path: 'profileView/:variable/:id',
        loadChildren: () => import('./modules/profile-view/profile-view.module').then(m => m.ProfileViewModule),
        canActivate: [CprRoleGuard],
      },
      {
        path: 'journeys',
        loadChildren: () => import('./modules/journeys/journeys.module').then(m => m.JourneysModule),
        canActivate: [MarketingRoleGuard]
      },
      {
        path: 'emails',
        loadChildren: () => import('./modules/emails/emails.module').then(m => m.EmailsModule),
        canActivate: [MarketingRoleGuard]
      },
      {
        path: 'texts',
        loadChildren: () => import('./modules/texts/texts.module').then(m => m.TextsModule),
        canActivate: [MarketingRoleGuard]
      },
      {
        path: 'tasks',
        loadChildren: () => import('./modules/tasks/tasks.module').then(m => m.TasksModule),
        canActivate:[MarketingRoleGuard]
      },
      {
        path: 'segments',
        loadChildren: () => import('./modules/segments/segments.module').then(m => m.SegmentsModule),
        canActivate:[MarketingRoleGuard]
      },
      {
        path: 'broadcast',
        loadChildren: () => import('./modules/broadcast/broadcast.module').then(m => m.BroadcastModule),
        canActivate: [MarketingRoleGuard]
      },
      {
        path: 'marketing/activities',
        loadChildren: () => import('./modules/marketing-activities/matketing-activities.module').then(m => m.MatketingActivitiesModule),
        canActivate: [MarketingRoleGuard]
      },
      // {
      //   path: 'cases',
      //   loadChildren: () => import('./modules/cases/cases.module').then(m => m.CasesModule),
      //   canActivate: [CaseManagementRoleGuard]
      // },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    ],
  },
  // {
  //   path: 'search',
  //   component: SearchComponent,
  // },
  {
    path: 'login',
    component: LoginComponent,
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
